import { ColorX } from "IZOX/STATIC";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import LoadingSpin from "react-loading-spin";

/**
 * 
 * @param {{
 *  size: Number,
 *  thickness: Number,
 *  primaryColor: String,
 *  secondaryColor: String,
 *  animationDuration: Number,
 *  animationTimingFunction: "ease-in-out",
 *  animationDirection: "normal",
 *  numberOfRotationsInAnimation: Number,
 *  loading: Boolean,
 *  darkMode: Boolean
 * }} param0 
 * @returns 
 */
function ActivityIndicator({
  size = 20,
  thickness = 4,
  primaryColor = ColorX.CSS("blue"),
  secondaryColor = ColorX.CSS("greyOut", 0.5),
  doneColor = ColorX.CSS("green"),
  darkPrimaryColor = ColorX.CSS("dmBtnBlue"),
  darkSecondaryColor = ColorX.CSS("greyOut", 0.3),
  darkDoneColor = ColorX.CSS("pureGreen"),
  animationDuration = 4,
  animationTimingFunction = "ease-in-out",
  animationDirection = "normal",
  numberOfRotationsInAnimation = 2,
  loading = false,
  darkMode = false
}){
  if(loading){
    return (
      <LoadingSpin
        size={size + "px"}
        width={thickness + "px"}
        primaryColor={darkMode ? darkPrimaryColor : primaryColor}
        secondaryColor={darkMode ? darkSecondaryColor : secondaryColor}
        animationDuration={animationDuration + "s"}
        animationTimingFunction={animationTimingFunction}
        animationDirection={animationDirection}
        numberOfRotationsInAnimation={numberOfRotationsInAnimation}
        />
    );
  }else{
    return (
      <IoMdCheckmarkCircleOutline style={{transition: "color 500ms"}}
        size={size} color={darkMode ? darkDoneColor : doneColor}/>
    );
  }
  
}

export default ActivityIndicator;